jPar.wdk = jPar.wdk || {};
$j.extend(true, jPar.wdk, {
	forms: {
		props: {
			selector: '',
		},

		init: function init(forSelector) {
			this.textElement.init(forSelector);
		},

		showError: function showError($errorElement) {
			if ($errorElement instanceof jQuery) {
				$errorElement.addClass('is-visible');
				$errorElement.attr('role', 'alert');
				$errorElement.attr('aria-hidden', 'false');
				$errorElement.removeAttr('inert');

				const $row = $errorElement.parents('.wdk-form-text, .wdk-form-toggles, .wdk-form-dropdown, .wdk-form-customDropdown');
				if ($row.length > 0) {
					$row.addClass('has-error');
					$row.find('input,textarea').attr('aria-invalid', 'true');
					$row.find('input,textarea').attr('aria-describedby', $errorElement.attr('id'));
				}
			} else if ($errorElement !== null && $errorElement.classList !== undefined) {
				// es gibt immer mal wieder einzelne User, die Fehler werfen, weil classList nicht da ist.
				$errorElement.classList.add('is-visible');
				$errorElement.setAttribute('role', 'alert');
				$errorElement.setAttribute('aria-hidden', 'false');
				$errorElement.removeAttribute('inert');

				const $row = $errorElement.closest('.wdk-form-text, .wdk-form-toggles, .wdk-form-dropdown, .wdk-form-customDropdown');
				if ($row !== null) {
					$row.classList.add('has-error');
					$row.querySelector('input,textarea,select').setAttribute('aria-invalid', 'true');
					$row.querySelector('input,textarea,select').setAttribute('aria-describedby', $errorElement.getAttribute('id'));
				}
			}
		},

		hideError: function hideError($errorElement) {
			if ($errorElement instanceof jQuery) {
				$errorElement.removeClass('is-visible');
				$errorElement.removeAttr('role');
				$errorElement.attr('aria-hidden', 'true');
				$errorElement.attr('inert', 'true');

				const $row = $errorElement.parents('.wdk-form-text, .wdk-form-toggles, .wdk-form-dropdown, .wdk-form-customDropdown');
				if ($row.find('.error.is-visible').length === 0) {
					// keine weiteren (und sichtbaren) Fehler mehr in der Reihe - für z.B. BE-Validierung / FE-Validierung in der selben Reihe
					$row.removeClass('has-error');
					$row.find('input,textarea').removeAttr('aria-invalid', 'false');
					$row.find('input,textarea').removeAttr('aria-describedby');
				}
			} else if ($errorElement !== null && $errorElement.classList !== undefined) {
				// es gibt immer mal wieder einzelne User, die Fehler werfen, weil classList nicht da ist.
				$errorElement.classList.remove('is-visible');
				$errorElement.removeAttribute('role');
				$errorElement.setAttribute('aria-hidden', 'true');
				$errorElement.setAttribute('inert', 'true');

				const row = $errorElement.closest('.wdk-form-text, .wdk-form-toggles, .wdk-form-dropdown, .wdk-form-customDropdown');

				if (row !== null && row.querySelector('.error.is-visible') === null) {
					row.classList.remove('has-error');
					const inputElements = row.querySelectorAll('input,textarea,select');
					inputElements.forEach((inputElement) => {
						inputElement.removeAttribute('aria-invalid');
						inputElement.removeAttribute('aria-describedby');
					});
				}
			}
		},

		hasVisibleErrors: function hasVisibleErrors($form) {
			if ($form instanceof jQuery) {
				return $form.find('.wdk-styledHintBox[class*=" t-error"].is-visible').length > 0;
			} else if ($form !== null && $form.classList !== undefined) {
				const hasWdkHintboxError = $form.querySelector('wdk-hintbox-error[show]') !== null;
				const hasLegacyHintboxError = $form.querySelectorAll('.wdk-styledHintBox[class*=" t-error"].is-visible').length > 0;
				return hasWdkHintboxError || hasLegacyHintboxError;
			}
		},

		textElement: {
			defaultSelector: '.wdk-form-text',
			selector: '',

			init: function init(forSelector) {
				this.setSelectorProperty(forSelector);
				this.initCharCounter();
			},

			setSelectorProperty: function (forSelector) {
				if (typeof forSelector !== 'undefined') {
					this.selector = forSelector + ' ' + this.defaultSelector;
				} else {
					this.selector = this.defaultSelector;
				}
			},

			initCharCounter: function () {
				const _this = this;
				const $textFormElements = $j(this.selector).find('textarea, input');

				$textFormElements.on('keyup blur change paste cut', function () {
					const $textfield = $j(this);

					window.setTimeout(function () {
						_this.updateCounter($textfield);
					}, 10); // Das paste Event braucht ein setTimeout
				});

				$textFormElements.each(function () {
					// Initiale Counterwerte setzen
					_this.updateCounter($j(this));
				});
			},

			updateCounter: function updateCounter($changedElement) {
				const hasMaxlength = $changedElement.attr('maxlength') !== undefined;

				if (hasMaxlength) {
					const maxChars = $changedElement.attr('maxlength');
					const nearLimitLength = (maxChars / 100) * 80;
					const changedValueLength = $changedElement.val().length;
					const $changedInputRow = $changedElement.parents(this.selector);
					const $limitReachedInfo = $changedInputRow.find('.limitReachedInfo');

					$changedInputRow.find('.charCounter span').text(changedValueLength);

					if (changedValueLength >= nearLimitLength) {
						$changedInputRow.addClass('is-nearLimit');
					} else {
						$changedInputRow.removeClass('is-nearLimit');
					}

					if (changedValueLength >= maxChars) {
						$changedInputRow.addClass('is-limitReached');

						if ($limitReachedInfo.length > 0) {
							$limitReachedInfo.text($limitReachedInfo.data('alertText'));
						}
					} else {
						$changedInputRow.removeClass('is-limitReached');
						$limitReachedInfo.text('');
					}
				}
			},
		},

		customDropdown: {
			callback: null,
			isAnimating: false,

			init: function init(forSelector, callback) {
				const _this = this;
				this.callback = callback;

				if ($j(forSelector).length > 0) {
					$j(forSelector)
						.find('.wdk-form-customDropdown a')
						.off('click keydown')
						.on('click keydown', function (event) {
							// off um sicher zu sein, das das event nicht mehrfach angewendet wird
							if (jPar.util.validate.isMouseclickEnterOrSpaceKey(event.keyCode)) {
								// A11y
								if (_this.isAnimating === true) {
									return;
								}
								_this.isAnimating = true;
								event.preventDefault();
								_this.toggle(event);

								setTimeout(function () {
									_this.isAnimating = false;
								}, 280);
							}
						});

					$j(forSelector)
						.find('.wdk-form-customDropdown li')
						.off('click keydown')
						.on('click keydown', function (event) {
							if (jPar.util.validate.isMouseclickEnterOrSpaceKey(event.keyCode)) {
								// A11y
								event.preventDefault();
								_this.selectCurrentElement(event);
							}
						});
				}
			},

			toggle: function toggle(event) {
				const $eventElement = $j(event.target);
				const $component = $eventElement.parents('.wdk-form-customDropdown');
				const $dropDown = $component.find('.selection');

				if ($component.hasClass('is-open')) {
					$component.removeClass('is-open');
				} else {
					$component.addClass('is-open');
				}

				$dropDown.slideToggle('fast');
			},

			selectCurrentElement: function selectCurrentElement(event) {
				const $item = $j(event.target);
				$item.parents('.wdk-form-customDropdown').find('.selection').find('li').removeClass('selectedListItem');
				$item.addClass('selectedListItem');
				$item.parents('.wdk-form-customDropdown').find('a').html($item.html());

				this.toggle(event);

				if (typeof this.callback === 'function') {
					$item.parents('.wdk-form-customDropdown').find('input[name="selectedItem"]').val($item.data('value'));
					this.callback(event);
				}
			},
		},

		autofillDropdown: {
			callback: null,

			initList: function init(forSelector, callback) {
				const _this = this;
				this.callback = callback;

				if ($j(forSelector).length > 0) {
					$j(forSelector)
						.find('.autofillDropdownDatalist li:not(.noResult)')
						.off('click')
						.on('click', function (event) {
							event.preventDefault();
							_this.selectCurrentElement(event);
						});
				}
			},

			initTextfield: function (wrapperSelector, callback) {
				const _this = this;
				let liPosition = 1;

				this.callback = callback;
				this.preventEnterToSubmitForm(wrapperSelector);

				$j(wrapperSelector)
					.find('.js-autofillDropdownTextfield')
					.on('click', function (event) {
						// beim Click auch triggern
						if (typeof _this.callback === 'function') {
							callback($j(event.target)); // do Ajax stuff
						}
					});

				$j(wrapperSelector)
					.find('.js-autofillDropdownTextfield')
					.on('keyup', function (event) {
						event.preventDefault();

						const keyArrowUp = event.keyCode === 38;
						const keyArrowDown = event.keyCode === 40;
						const keyEnter = event.keyCode === 13;
						const $keyboarSelectedItem = $j(wrapperSelector).find('.autofillDropdownDatalist .selection li.isKeyboardSelected');

						if (keyArrowUp || keyArrowDown) {
							const listLength = $j(wrapperSelector).find('.autofillDropdownDatalist .selection li').length;
							if (listLength > 0) {
								liPosition = $keyboarSelectedItem.index() + 1; // index beginnt bei 0 / nth-child bei 1
								const notTopPositionOnKeyUp = keyArrowUp && liPosition > 1;
								const notLastPositionOnKeyDown = keyArrowDown && liPosition < listLength;

								if (notTopPositionOnKeyUp) {
									liPosition = liPosition - 1;
								} else if (notLastPositionOnKeyDown) {
									liPosition = liPosition + 1;
								}

								$keyboarSelectedItem.removeClass('isKeyboardSelected');
								$j(wrapperSelector).find(`.autofillDropdownDatalist .selection li:nth-child(${liPosition})`).addClass('isKeyboardSelected');
								$j(wrapperSelector)
									.find('.js-autofillDropdownTextfield')
									.attr('aria-activedescendant', 'autocompleteOption' + liPosition);
								if ($j(wrapperSelector).find('.isKeyboardSelected').length) {
									$j(wrapperSelector).find('.isKeyboardSelected')[0].scrollIntoView(true);
								}
							}
						} else if (keyEnter && $keyboarSelectedItem.length === 1) {
							$keyboarSelectedItem.trigger('click');
						} else {
							// if(/[a-zA-Z0-9\s]/.test(stringFromCharCode) || deleteKeys){ //Android gibt keine richtigen keyCodes raus https://bugs.chromium.org/p/chromium/issues/detail?id=118639
							if (typeof _this.callback === 'function') {
								callback($j(event.target)); // do Ajax stuff
							}
						}
					});
			},

			preventEnterToSubmitForm: function (wrapperSelector) {
				$j(wrapperSelector)
					.find('.js-autofillDropdownTextfield')
					.on('keydown', function (event) {
						if (event.keyCode === 13) {
							event.preventDefault();
						}
					});
			},

			open: function ($component) {
				const $dropDown = $component.find('.selection');
				$component.parents('.row').find('.js-autofillDropdownTextfield').attr('aria-expanded', 'true');
				$component.addClass('is-open');
				$dropDown.slideDown('fast');
			},

			close: function ($component) {
				const $dropDown = $component.find('.selection');
				$component.parents('.row').find('.js-autofillDropdownTextfield').attr('aria-expanded', 'false');
				$component.removeClass('is-open');
				$dropDown.slideUp('fast');
			},

			selectCurrentElement: function (event) {
				const $item = $j(event.target);
				this.close($item.parents('.wdk-form-autofillDropdown .autofillDropdownDatalist'));

				const itemText = $item.text();
				$item.parents('.wdk-form-autofillDropdown').find('.js-autofillDropdownTextfield').val(itemText);

				if (typeof this.callback === 'function') {
					this.callback($item);
				}
			},
		},
	},
});
